/**
 * StackView — application stack grid (BR-U5-08 through BR-U5-12).
 *
 * Maps the stacks list to ApplicationStackCard instances.
 * Shows a loading skeleton or empty state when appropriate.
 */
import type { ApplicationStack } from '@/types';
import { ApplicationStackCard } from './ApplicationStackCard';
import styles from './StackView.module.css';

export interface StackViewProps {
  stacks: ApplicationStack[];
  isLoading: boolean;
}

export function StackView({ stacks, isLoading }: StackViewProps) {
  if (isLoading) {
    return (
      <div className={styles.grid} aria-busy="true" aria-label="Loading stacks">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className={styles.skeleton} aria-hidden="true" />
        ))}
      </div>
    );
  }

  if (stacks.length === 0) {
    return (
      <div className={styles.empty} role="status">
        <p>No application stacks match the current filters.</p>
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {stacks.map((stack) => (
        <ApplicationStackCard
          key={`${stack.applicationName}::${stack.environment}`}
          stack={stack}
        />
      ))}
    </div>
  );
}
